import { QueryTuple, useLazyQuery } from '@apollo/client';
import { WorkPackageStats, WorkPackageStatsInput } from '@bechtel/types';
import { DASHBOARD_STATS } from '@bechtel/client-gql';

export function useDashboardStatsQuery(): QueryTuple<
  { workPackageStats: WorkPackageStats },
  { input: WorkPackageStatsInput }
> {
  const response = useLazyQuery<{ workPackageStats: WorkPackageStats }, { input: WorkPackageStatsInput }>(
    DASHBOARD_STATS,
    {
      notifyOnNetworkStatusChange: true,
      fetchPolicy: 'network-only',
      nextFetchPolicy: 'cache-first',
    }
  );
  return response;
}
